<template>
  <div>
    <div class="complaint-work-order">
      <div style="color: #00A551">
        <span>{{ $t('driver.platform01') }}</span>
        <span style="margin: 0 10px">{{ replyMessageData.platform }}</span>
        <span>{{ $t('GlobalSetObj.ScanNumber') }}:</span>
        <span style="margin: 0 10px">{{ replyMessageData.scanNumber }}</span>
        <span>{{ $t('driver.recipientCPF') }}:</span>
        <span style="margin: 0 10px">{{ replyMessageData.receiveTax }}</span>
        <span>{{ $t('orderCenterCont.telephoneNumber') }}:</span>
        <span style="margin: 0 10px">{{ replyMessageData.receiveMobile }}</span>
      </div>
      <div ref="messageListRef" class="message-content-bg">
        <div v-for="(item, index) in messageDetail" :key="index">
          <div v-if="item.createUser !== currentId" style="margin-bottom: 15px">
            <div style="text-align: left">
              <div>
                <img
                  v-if="item.type === 1"
                  :src="cs"
                  alt="cs"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else-if="item.type === 3"
                  :src="dc"
                  alt="dc"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else :src="aj" alt="aj"
                  class="img" style="width: 50px !important"
                >
              </div>
              <div style="margin-top: -60px; margin-left: 60px">
                <div>
                  <span
                    :style="{
                      color: item.type === 2 ? '#ffb907' : '#00A551'
                    }"
                  >{{ item.createUserName }}</span>
                  <span style="margin-left: 10px">{{ item.createTime }}</span>
                </div>
                <div>
                  <div
                    :style="{
                      float: 'left',
                      backgroundColor: item.type === 2 ? '#f6f0df' : '#ffffff'
                    }"
                    class="complaint-work-order-message-content"
                  >
                    <div
                      class="wrap-text"
                      style="text-align: left; max-width: 720px"
                      @click.stop="getImgSrc"
                      v-html="item.message"
                    />
                    <div v-if="item.mediaUrl" style="margin-top: 10px">
                      <el-image
                        v-for="(url, ind) in item.mediaUrlList"
                        :key="ind"
                        :preview-src-list="item.mediaUrlList"
                        :src="url"
                        style="width: 100px; height: 100px"
                      />
                    </div>
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </div>
          </div>
          <div v-else style="margin-bottom: 15px">
            <div style="text-align: right">
              <div>
                <img
                  v-if="item.type === 1"
                  :src="cs"
                  alt="cs"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else-if="item.type === 3"
                  :src="dc"
                  alt="dc"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else :src="aj" alt="aj"
                  class="img" style="width: 50px !important"
                >
              </div>
              <div style="margin-top: -60px; margin-right: 60px; text-align: right">
                <div>
                  <span style="margin-right: 10px">{{ item.createTime }}</span>
                  <span
                    :style="{
                      color: item.type === 2 ? '#ffb907' : '#00A551'
                    }"
                  >{{ item.createUserName }}</span>
                </div>
                <div>
                  <div
                    class="complaint-work-order-message-content"
                    style="float: right; background-color: #c6e6f4"
                  >
                    <div
                      class="wrap-text"
                      style="text-align: left; max-width: 720px"
                      @click.stop="getImgSrc"
                      v-html="item.message"
                    />
                    <div v-if="item.mediaUrl" style="margin-top: 10px">
                      <el-image
                        v-for="(url, ind) in item.mediaUrlList"
                        :key="ind"
                        :preview-src-list="item.mediaUrlList"
                        :src="url"
                        style="width: 100px; height: 100px"
                      />
                    </div>
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 10px; margin-top: 20px">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        class="demo-ruleForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!--  异常事件描述  -->
            <el-form-item prop="contentValue">
              <el-input
                ref="inputRef"
                v-model="ruleForm.contentValue"
                :maxlength="3000"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                :rows="5"
                class="red-text-input"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flx-between">
        <div>
          <el-upload
            ref="uploadRef"
            v-model="ruleForm.photograph"
            :before-upload="beforeAvatarUpload"
            :file-list="imageList"
            :http-request="upLoad"
            :limit="3"
            :on-exceed="handleExceed"
            :on-remove="handleDeleteImgRemove"
            action="#"
            list-type="picture-card"
            multiple
          >
            <i class="iconfont icon-tupiantianjia" style="font-size: 20px" />
          </el-upload>
          <div style="color: #606266; font-size: 14px">{{ $t('fixDutyFine.addPhotos') }}</div>
        </div>
        <el-button
          :loading="loadingBtn" type="primary" @click="submitMsg('ruleForm')"
        >{{ $t('GlobalSetObj.Reply') }}
        </el-button>
      </div>
    </div>
    <!--    <div style="padding: 10px; text-align: right">-->
    <!--      <el-button-->
    <!--        size="small" type="primary" @click="submitMsg"-->
    <!--      >{{ $t('GlobalSetObj.Reply') }} </el-button>&lt;!&ndash;回复&ndash;&gt;-->
    <!--    </div>-->
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { apiGetComplaintWorkGetMessage, apiGetComplaintWorkSendMessage } from '@/api/newExpressAPI';
import anjunService from '@/assets/images/anjunService.png';
import CustomerService from '@/assets/images/CustomerService.png';
import DeliveryClerk from '@/assets/images/DeliveryClerk.png';
import { uploadOos } from '@/utils/ali_oos_util';

export default {
  components: { ElImageViewer },
  props: {
    replyMessageData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      ruleForm: {
        contentValue: '',
        photograph: ''
      },
      aj: anjunService,
      cs: CustomerService,
      dc: DeliveryClerk,
      messageDetail: [],
      getIntervalMsg: null,
      showViewer: false,
      imgArr: [],
      currentId: this.$store.state.user.id,
      msgPlugin: [''],
      toolbar: [''],
      getItem: 0,
      pictureList: [],
      imageList: [],
      loadingBtn: false,
      uploadingCount: 0 // 跟踪正在上传的文件数量
    };
  },
  mounted() {
    this.imageList = [];
    this.pictureList = [];
    this.ruleForm.photograph = '';
    this.ruleForm.contentValue = '';
    this.getMessageData();
    this.getIntervalMsg = setInterval(() => {
      this.getMessageData();
    }, 5000);
  },
  methods: {
    // 上传图片
    async upLoad(option) {
      const files = option.file;
      try {
        const res = await uploadOos(files, 'eventImages');
        if (res.code === 200) {
          this.ruleForm.photograph = res.url;
          if (this.pictureList.length < 3) {
            this.pictureList.push({
              url: res.url,
              uid: files.uid
            });
          }
        } else {
          // 上传图片失败
          this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
        }
      } catch (e) {
        // 上传图片失败
        this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
      } finally {
        this.uploadingCount--;
        this.checkUploadComplete();
      }
    },
    // 检查是否所有上传都已完成
    checkUploadComplete() {
      if (this.uploadingCount === 0 && this.loadingBtn) {
        this.loadingBtn = false;
      }
    },
    // 移除触发的钩子
    handleDeleteImgRemove(file, fileList) {
      console.log(file, fileList);
      if (file.uid) {
        const uid = file.uid;
        const findIndex = this.pictureList.findIndex((url) => url.uid === uid);
        console.log(findIndex, 'findIndex');
        this.pictureList.splice(findIndex, 1);
        console.log(this.pictureList, 'this.pictureList');
      }
      if (this.pictureList.length === 0) {
        this.ruleForm.photograph = '';
      }
    },
    handleExceed(file, fileList) {
      if (fileList.length >= 3) {
        this.$message.error('最多只能上传3张图片');
      }
    },
    // 图片上传前
    beforeAvatarUpload(rawFile) {
      // 获取文件扩展名
      const extension = rawFile.name.split('.').pop().toLowerCase();
      // 支持的图片格式
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
      // 检查文件格式是否为图片格式
      if (!allowedExtensions.includes(extension)) {
        this.$message.error(this.$t('fixDutyFine.formatFile'));
      } else {
        // 开始上传时增加计数并显示loading
        this.uploadingCount++;
        this.loadingBtn = true;
      }

      return allowedExtensions.includes(extension);
    },
    // 查看图片
    getImgSrcFile(url) {
      function getFileExtension(url) {
        // 使用正则表达式匹配最后一个点之后的部分作为文件扩展名
        const match = url.match(/\.([a-zA-Z0-9]+)(?:[\?#]|$)/);
        if (match) {
          return match[1].toLowerCase();
        }
        return '';
      }

      function isImage(extension) {
        // 定义常见的图片文件扩展名
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
        return imageExtensions.includes(extension);
      }

      const extension = getFileExtension(url);
      if (isImage(extension)) {
        this.imgArr = [url];
        this.showViewer = true;
      } else {
        window.open(url);
      }
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 获取回复消息
    getMessageData() {
      const param = {
        pageNumber: 1,
        pageSize: 1000,
        params: {
          messageId: this.replyMessageData.id
        }
      };
      apiGetComplaintWorkGetMessage(param, false).then((res) => {
        if (res.code === 200) {
          this.messageDetail = res.data.records;
          this.messageDetail.forEach((item) => {
            if (item.mediaUrl) {
              let mediaUrlList = [];
              mediaUrlList = item.mediaUrl.split(',');
              item.mediaUrlList = mediaUrlList;
            }
          });
          if (this.getItem === 0) {
            this.scrollToBottom();
            this.getItem++;
          }
        }
      });
    },
    // 判断是否是存在html标签
    isHtml(str) {
      const reg = /<[^>]+>/g;
      return reg.test(str);
    },
    // 提交回复
    submitMsg() {
      if (this.ruleForm.contentValue === '' && this.pictureList.length === 0) {
        this.$message.warning(this.$t('GlobalSetObj.MessageContentAndFileCannotBeEmpty')); // 消息内容和上传文件不能同时为空
        return;
      }
      const param = {
        messageId: this.replyMessageData.id,
        message: this.ruleForm.contentValue,
        mediaUrl: ''
      };
      // 查找所有的 img 元素
      const imageList = [];
      this.pictureList.forEach((item) => {
        imageList.push(item.url);
      });
      if (imageList.length <= 3) {
        param.mediaUrl = imageList.join(',');
      }
      apiGetComplaintWorkSendMessage(param, false).then((res) => {
        if (res.code === 200) {
          this.getMessageData();
          this.imageList = [];
          this.pictureList = [];
          this.ruleForm.photograph = '';
          this.ruleForm.contentValue = '';
          this.$refs.inputRef.focus();
          this.scrollToBottom();
        }
      });
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        // 延迟 100ms 确保所有内容加载完成
        setTimeout(() => {
          this.$refs.messageListRef.scrollTo(0, this.$refs.messageListRef.scrollHeight);
        }, 100);
      });
    }
  }
};
</script>

<style scoped>
.message-content-bg {
  overflow-y: auto;
  background-color: #f5f5f5;
  padding: 10px 5px;
  height: 100%;
  border-radius: 5px;
}

.complaint-work-order {
  height: calc(100vh - 350px);
  border-radius: 5px;
  padding: 10px;
}

.complaint-work-order-message-content {
  padding: 15px;
  border-radius: 5px;
}

.files-update-complaint-work .el-upload-list {
  height: 35px;
  overflow-y: auto;
}

::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}

::v-deep .el-input__inner {
  color: red !important;
}

.wrap-text {
  /* 核心换行样式 */
  word-wrap: break-word; /* 兼容旧浏览器，允许在单词内换行 */
  word-break: break-all; /* 强制换行，无论是否是单词边界（适配长URL/连续字符） */
  white-space: normal; /* 恢复默认换行，覆盖可能的 white-space: nowrap */
  overflow-wrap: break-word; /* 现代浏览器标准，优先在单词间隙换行，无间隙则强制换行 */
  overflow: hidden; /* 防止内容超出容器（可选） */
  line-height: 1.5; /* 优化换行后行间距，提升可读性 */
}
</style>
